import { ONBOARDING_PAYWALL_ASSETS } from "@/src/components/ChatOnboarding/constants/onboardingPaywallAssets";

/** Figma H5 `96138:32739` / card `96097:351742` — 卡片头图 */
export const FREE_PLAN_OFFER_CARD_BG =
  ONBOARDING_PAYWALL_ASSETS.freePlanOfferHero;
